import { Controller } from "@hotwired/stimulus"

// This controller is used to manage a group of filters, it currently supports the checkbox and input filters.
export default class extends Controller {
  static get values() {
    return { filters: Object }
  }

  static get targets() {
    return ["dataCount", "filter"]
  }

  connect() {
    this._count()
  }

  clear() {
    this.filterTargets.forEach(filter => {
      ["check-all", "filters--checkbox-filter", "filters--input-filter", "filters--number-input-filter"].forEach(identifier => {
        const controller = this.application.getControllerForElementAndIdentifier(filter, identifier)

        if (controller) {
          controller.clear()
        }
      })
    })

    this.filtersValue = {}
    this._count()
  }

  filter(event) {
    let filters = this.filtersValue

    if (event.detail.values && event.detail.values.length > 0) {
      filters[event.detail.name] = event.detail.values
    } else {
      delete filters[event.detail.name]
    }

    this.filtersValue = filters
    this._count()
  }

  // This counts the total number of values from all the included filters.
  _count() {
    if (this.hasDataCountTarget) {
      let selectedOptions = Object.values(this.filtersValue).flat().length

      if (selectedOptions > 0) {
        this.dataCountTarget.dataset.count = selectedOptions
      } else {
        delete this.dataCountTarget.dataset.count
      }
    }
  }
}
